import { ApolloClient, InMemoryCache, ApolloLink } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

const uri = process.env.REACT_APP_GRAPHQL_URI;

const uploadLink = createUploadLink({
  uri,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

const authLink = setContext((_, { headers, ...rest }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
    ...rest,
  };
});

const uploadLinkWithAuth = authLink.concat(uploadLink);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log("TCL: errorLink -> message", message);

      console.log(
        `[GraphQL error]: Message: ${JSON.stringify(
          message
        )}, Location: ${JSON.stringify(locations)}, Path: ${path}`
      );
    });

  if (networkError) {
    console.log("[Network error]:", networkError);
  }
});

const cache = new InMemoryCache({
  dataIdFromObject: (o) => o.uid,
});

export default new ApolloClient({
  cache,
  link: ApolloLink.from([errorLink, uploadLinkWithAuth]),
  connectToDevTools: true,
});
